document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.video-slider-section').forEach((section) => {
    const sliderEl = section.querySelector('.video-slider');
    if (!sliderEl) return;

    const videos = section.querySelectorAll('video');
    const slides = section.querySelectorAll('.swiper-slide');
    const progressBar = section.querySelector('.video-progress-line');
    let hasBeenVisible = false;
    let rafId = null;

    const swiper = new Swiper(sliderEl, {
      slidesPerView: 'auto',
      loop: true,
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
      },
      pagination: {
        el: section.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
      on: {
        init() {
          setupMuteButtons();
          handleVideoAutoplay(this);
        },
        slideChangeTransitionEnd() {
          handleVideoAutoplay(this);
        },
      },
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !hasBeenVisible) {
          hasBeenVisible = true;
          handleVideoAutoplay(swiper);
        }
      });
    }, {
      threshold: 0.3,
    });

    observer.observe(section);

    function handleVideoAutoplay(swiperInstance) {
      if (!hasBeenVisible) return;

      videos.forEach((video) => video.pause());
      cancelAnimationFrame(rafId);
      if (progressBar) progressBar.style.width = '0%';

      const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
      const activeVideo = activeSlide.querySelector('video');

      if (activeVideo) {
        activeVideo.play().catch(() => {});
        setupVideoEndHandler(activeVideo, swiperInstance);
        updateProgressBar(activeVideo);
      }
    }

    function setupVideoEndHandler(video, swiperInstance) {
      video.onended = () => {
        cancelAnimationFrame(rafId);
        swiperInstance.slideNext();
      };
    }

    function updateProgressBar(video) {
      const update = () => {
        if (video.duration) {
          const percent = (video.currentTime / video.duration) * 100;
          if (progressBar) progressBar.style.width = `${percent}%`;
        }
        rafId = requestAnimationFrame(update);
      };
      rafId = requestAnimationFrame(update);
    }

    function setupMuteButtons() {
      slides.forEach((slide) => {
        const video = slide.querySelector('video');
        const btn = slide.querySelector('.muted-btn');
        const icon = btn.querySelector('i');
        const span = btn.querySelector('span');

        if (!video || !btn || !icon || !span) return;

        btn.addEventListener('click', () => {
          video.muted = !video.muted;
          if (video.muted) {
            icon.classList.remove('fa-volume');
            icon.classList.add('fa-volume-slash');
            span.textContent = 'TAP FOR SOUND';
          } else {
            icon.classList.remove('fa-volume-slash');
            icon.classList.add('fa-volume');
            span.textContent = 'TAP FOR MUTE';
          }
        });
      });
    }
  });
});